import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import SmoothLoader from './components/SmoothLoader.tsx';

// SEO optimization - Report web vitals for monitoring and improvement
const reportWebVitals = (onPerfEntry?: any) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry); // Cumulative Layout Shift
      getFID(onPerfEntry); // First Input Delay
      getFCP(onPerfEntry); // First Contentful Paint
      getLCP(onPerfEntry); // Largest Contentful Paint
      getTTFB(onPerfEntry); // Time to First Byte
    });
  }
};

// Simple loading fallback for Suspense
const SimpleFallback = () => <div className="hidden">Loading...</div>;

// Render with SmoothLoader for a smooth transition
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <SmoothLoader>
      <Suspense fallback={<SimpleFallback />}>
        <App />
      </Suspense>
    </SmoothLoader>
  </React.StrictMode>,
);

// Report vitals in production
if (process.env.NODE_ENV === 'production') {
  reportWebVitals(console.log);
}
